import { Box, Icon, Link, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import moment from 'moment';
import React, { useContext } from 'react';

import { ConferenceContext } from '@/store';
import UserAvatar from '@/components/ui/userAvatar';
import { DiscussionConnection } from './DiscussionConnection';

const itemStyles = (theme) => ({
  title: {
    textAlign: 'left !important',
  },
  titleText: {
    fontSize: '1.25rem !important',
    lineHeight: '1.2 !important',
  },
  link: {
    color: `${theme.palette.text.primary} !important`,
    textDecoration: 'none !important',
    '&:hover': {
      textDecoration: 'underline !important',
    },
  },
  arrowButton: {
    color: `${theme.palette.text.primary} !important`,
    padding: '5px !important',
    paddingTop: '0px !important',
    opacity: '0.6 !important',
    '&:hover': {
      opacity: '1 !important',
    },
  },
  holder: {
    cursor: 'pointer !important',
    display: 'flex !important',
    textAlign: 'left !important',
    width: '100% !important',
    borderTopColor: `${theme.palette.background.shadedown_20} !important`,
    borderTopStyle: 'solid !important',
    borderTopWidth: '1px !important',
    paddingTop: '8px !important',
    paddingBottom: '16px !important',
    alignItems: 'flex-start !important',
    '&:hover': {
      backgroundColor: `${theme.palette.background.shadedown_20} !important`,
    },
  },
  replies: {
    textDecoration: 'underline !important',
  },
  content: {
    position: 'relative !important',
    width: '100% !important',
  },
  pin: {
    position: 'absolute !important',
    top: '0px !important',
    right: '0px !important',
    backgroundColor: `${theme.palette.background.default} !important`,
    padding: '5px !important',
    opacity: '0.6 !important',
    '& > *': {
      fontSize: '1rem !important',
    },
  },
  timeAgo: {
    // paddingLeft: 8,
    fontSize: '0.75rem !important',
    opacity: '0.5 !important',
    fontStyle: 'italic !important',
  },
  eventCircle: {
    display: 'inline-block !important',
    marginRight: '8px !important',
    width: '12px !important',
    height: '12px !important',
    borderRadius: '12px !important',
    backgroundColor: `${theme.palette.primary.main} !important`,
  },
  info: {
    fontSize: '12px !important',
    padding: '5px !important',
    width: '30px !important',
    textAlign: 'center !important',
  },
  avatar: {
    marginTop: '5px !important',
    marginRight: '8px !important',
  },
  topic: {
    textTransform: 'uppercase !important',
    backgroundColor: `${theme.palette.text.primary} !important`,
    color: `${theme.palette.background.default} !important`,
    padding: '2px !important',
    fontSize: '0.7rem !important',
    borderRadius: '3px !important',
    opacity: '0.6 !important',
  },
});

export const DiscussionDetail = (props) => {
  const theme = useTheme();
  const classes = itemStyles(theme, {
    alwaysSmall: props.alwaysSmall,
  });
  // const { authState } = useContext(AuthContext);

  const { conferenceState, openUserPopup } = useContext(ConferenceContext);
  const fullyDisplayed =
    props.discussion.state === 'show' ||
    props.discussion.state === 'in_connection';

  const lastReply = moment
    .utc(props.discussion.last_message_date)
    .utcOffset(-conferenceState.conferenceDetail.utc_offset)
    .fromNow();

  const connectionData =
    props.discussion.connection_type !== null && !props.isEmbedded
      ? props.discussion[props.discussion.connection_type]
      : null;
  return (
    <Box
      onClick={() => props.gotoDiscussion(props.discussion.id)}
      sx={classes.holder}
      style={{ opacity: fullyDisplayed ? 1 : 0.7 }}
    >
      {/*
      Vi väntar med up/down vote tills vi har en vettig aloritm för sortering
      <Box>
        <Box display="flex" flexDirection="column">
          <ButtonBase className={classes.arrowButton}>
            <Icon>arrow_drop_up</Icon>
          </ButtonBase>
          {authState.user.access_level === C.VISITOR.ACCESS_LEVEL.MODERATOR && (
            <ButtonBase className={classes.arrowButton}>
              <Icon>arrow_drop_down</Icon>
            </ButtonBase>
          )}
        </Box>
      </Box>
          */}
      <Box sx={classes.avatar}>
        <UserAvatar user={props.discussion.visitor} size="small" />
      </Box>
      <Box flexGrow={1} pb={1} sx={classes.content}>
        {props.discussion.state === 'suggested' && (
          <Box>Suggested, sent to moderator</Box>
        )}
        {props.discussion.state === 'hidden' && (
          <Box>Hidden, only moderators can see</Box>
        )}
        <Box sx={classes.title}>
          <Typography variant="body2" sx={classes.titleText}>
            {props.discussion.title}
          </Typography>
        </Box>
        {props.discussion.visitor && (
          <Box>by {props.discussion.visitor.full_name}</Box>
        )}
        {props.discussion.nr_messages > 0 && (
          <Box>
            <Box component="span" sx={classes.timeAgo}>
              Last reply {lastReply}
            </Box>
          </Box>
        )}

        {props.discussion.url && (
          <Box pt={1}>
            <Link target="_blank" href={props.discussion.url}>
              {props.discussion.url}
            </Link>
          </Box>
        )}
        {connectionData && (
          <Box pt={1}>
            <DiscussionConnection
              type={props.discussion.connection_type}
              picture={connectionData.picture}
              title={connectionData.title}
            />
          </Box>
        )}

        {props.discussion.pinned > 0 && (
          <Box sx={classes.pin}>
            <Icon>push_pin</Icon>
          </Box>
        )}
        {props.discussion.text && (
          <Box pt={1}>
            {props.discussion.text.length > 120
              ? `${props.discussion.text.substring(0, 120)}...`
              : props.discussion.text}
          </Box>
        )}
        {props.discussion.discussion_topic && (
          <Box pt={1}>
            <Box component="span" sx={classes.topic}>
              # {props.discussion.discussion_topic.title}
            </Box>
          </Box>
        )}
      </Box>
      <Box sx={classes.info}>
        <Icon fontSize="small">comment</Icon>
        {props.discussion.nr_messages}
      </Box>
      <Box sx={classes.info}>
        <Icon fontSize="small">visibility</Icon>
        <br />
        {props.discussion.views > 999
          ? `${props.discussion.views.toString().substring(0, 1)}K`
          : props.discussion.views}
      </Box>
    </Box>
  );
};

DiscussionDetail.displayName = 'DiscussionDetail';
